import React, { useState, useEffect } from "react";
import "../BacBo.css"; // Arquivo CSS específico para BacBo
import HeaderLogo from "../Home/headerLogo";
// Importe o componente de barra de progresso circular
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function Bacbo() {
  const [maxJogadas, setMaxJogadas] = useState(0);
  const [contador, setContador] = useState("03:00");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [entradaStatus, setEntradaStatus] = useState("🔐 POSSÍVEL FALHA 🔐");
  const [isTimerActive, setIsTimerActive] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [webUrl, setWebUrl] = useState("https://topu2020.com/BqtjStHQ/");
  const [probabilidadeVitoria, setProbabilidadeVitoria] = useState(null);
  const [hackSuccess, setHackSuccess] = useState(false);

  useEffect(() => {
    let intervalId;

    if (isTimerActive && contador !== "00:00") {
      intervalId = setInterval(() => {
        const [minutos, segundos] = contador.split(":").map(Number);
        if (segundos > 0) {
          setContador(
            `${minutos.toString().padStart(2, "0")}:${(segundos - 1)
              .toString()
              .padStart(2, "0")}`
          );
        } else if (minutos > 0) {
          setContador(`${(minutos - 1).toString().padStart(2, "0")}:59`);
        } else {
          setIsTimerActive(false);
          setContador("03:00");
          setIsButtonDisabled(false);
          setEntradaStatus("🔐 POSSÍVEL FALHA 🔐");
          clearInterval(intervalId);
        }
      }, 1000);
    } else if (isTimerActive && contador === "00:00") {
      setIsTimerActive(false);
      setContador("03:00");
      setIsButtonDisabled(false);
      setEntradaStatus("🔐 POSSÍVEL FALHA 🔐");
    }

    return () => clearInterval(intervalId);
  }, [isTimerActive, contador]);

  const getRandomNumber = () => {
    const randomIndex = Math.floor(Math.random() * 2);
    return randomIndex === 0 ? 10 : 30;
  };

  const handleHackearSinal = () => {
    setIsLoading(true);
    setTimeout(() => {
      // Gera estratégias específicas para BacBo
      const estrategias = [
        "🎯 BANKER",
        "🎯 PLAYER", 
        "🎯 TIE"
      ];
      
      const estrategiaEscolhida = estrategias[Math.floor(Math.random() * estrategias.length)];
      
      // Gera uma sequência de apostas para BacBo
      const sequencias = [
        "B-P-B",
        "P-B-P", 
        "B-B-P",
        "P-P-B",
        "T-B-P"
      ];
      
      const sequenciaEscolhida = sequencias[Math.floor(Math.random() * sequencias.length)];

      const statusMessage = `✨ Sinal BacBo Detectado!

      🎯 Apostar em: ${estrategiaEscolhida}
      📊 Sequência: ${sequenciaEscolhida}
      
      💰 Valor sugerido: 2-5% do saldo
      🔄 Martingale: Até 2x se necessário
      ⚠️ Pare após 3 vitórias consecutivas
      `;

      setEntradaStatus(statusMessage.trim());
      setIsTimerActive(true);
      setIsLoading(false);
      setIsButtonDisabled(true);
      
      // Gera uma nova probabilidade de vitória
      let probabilidade =
        Math.random() < 0.85 ? Math.random() * 15 + 80 : Math.random() * 100;
      setProbabilidadeVitoria(Math.round(probabilidade));
    }, 8000);
  };

  // Função para retornar a cor baseada na probabilidade de vitória
  const getProbabilidadeColor = (probabilidade) => {
    if (probabilidade > 75) return "#00C851"; // verde
    if (probabilidade >= 50 && probabilidade <= 74) return "#ffbb33"; // laranja
    return "#ff4444"; // vermelho
  };

  // Função para retornar a cor do texto baseada na probabilidade de vitória
  const getProbabilidadeTextColor = (probabilidade) => {
    if (probabilidade > 75) return "green"; // verde
    if (probabilidade >= 50 && probabilidade <= 74) return "orange"; // laranja
    return "red"; // vermelho
  };

  return (
    <div className="bacbo-background">
      <div className="bacbo-container">
        <HeaderLogo />
        <img
          src={require("../../imgs/bacbo.jpg")} // Usando a imagem do BacBo
          alt="BacBo"
          className="bacbo-logo"
        />
        <div className="bacbo-float-box">
          <p className="bacbo-entrada-text">{entradaStatus}</p>
          {isLoading ? (
            <p className="bacbo-info-text">
              🔄 Analisando padrões do BacBo... Por favor, aguarde.
            </p>
          ) : (
            <>
              {!isTimerActive && (
                <p className="bacbo-info-text">
                  🔍 Procurando padrões no BacBo... Fique atento! 🎯
                </p>
              )}
              <p className="bacbo-info-text">
                ⌛ Jogue até acabar o tempo: {contador}
              </p>
              <div
                className={`bacbo-info-text ${isTimerActive ? "hidden" : ""}`}
              >
                <p className="bacbo-info-text">
                  👇 Clique no Botão para Hackear o Sinal
                </p>
                <div className="button-wrapper">
                  <button
                    className={`bacbo-button ${
                      hackSuccess ? "hack-success" : ""
                    }`}
                    onClick={handleHackearSinal}
                    disabled={isButtonDisabled}
                  >
                    <img
                      src={require("../../assets/Icon_hacker.png")}
                      alt="Icon"
                      className="button-icon"
                    />
                    Hackear Sinal BacBo
                  </button>
                </div>
              </div>

              <div
                className={`progress-container ${
                  isTimerActive ? "" : "hidden"
                }`}
              >
                {probabilidadeVitoria !== null && (
                  <div className="progress-container">
                    <div className="progress-bar">
                      <CircularProgressbar
                        value={probabilidadeVitoria}
                        text={`${probabilidadeVitoria}%`}
                        styles={buildStyles({
                          pathColor:
                            getProbabilidadeColor(probabilidadeVitoria),
                          textColor:
                            getProbabilidadeTextColor(probabilidadeVitoria),
                          textSize: "35px",
                          pathTransitionDuration: 0.5,
                        })}
                      />
                    </div>
                    <div className="probabilidade-info">
                      <p className="probabilidade-texto">{`Probabilidade de Vitória: ${probabilidadeVitoria}%`}</p>
                      {probabilidadeVitoria < 50 && (
                        <p className="alerta-probabilidade-baixa">
                          <br></br>Considere aguardar um melhor momento para jogar BacBo.
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Bacbo;
